// extracted by mini-css-extract-plugin
export default {"root":"ProfileSettingsInfo_root__0OmJ5","text":"ProfileSettingsInfo_text__tH1Wa"};